import React, { FC } from 'react';

import { useTheme } from '@webtrader/core/services/theme/v2';

import Ionicons from '@/components/Icons/Ionic';

interface IProps {}

const ActionSheetCheckmarkIcon: FC<IProps> = () => {
  const { theme } = useTheme();

  return <Ionicons name="checkmark-sharp" color={theme.colors.primary} />;
};

export default ActionSheetCheckmarkIcon;
